<app-paco-dialog [title]="'dataManagement.dataExchangeRequests.editDeadlineDialog.title' | transloco" [actions]="dialogActions()" (actionTriggered)="onDialogAction($event)">
  <mat-form-field appearance="outline" class="full-width mat__content">
    <mat-label>{{ 'dataManagement.dataExchangeRequests.editDeadlineDialog.label' | transloco }}</mat-label>

    <input matInput [matDatepicker]="deadlinePicker" [formControl]="deadlineControl" [min]="minSelectableDeadline" />

    <mat-datepicker-toggle matSuffix [for]="deadlinePicker" />

    <mat-datepicker #deadlinePicker />

    @if (deadlineControl.hasError('matDatepickerMin')) {
      <mat-error>
        {{ 'dataManagement.dataExchangeRequests.editDeadlineDialog.pastError' | transloco }}
      </mat-error>
    }
  </mat-form-field>
  @if (deadlineControl.value) {
    <button mat-button class="clear-button" type="button" (click)="clearDeadline()">
      {{ 'dataManagement.dataExchangeRequests.editDeadlineDialog.clearAction' | transloco }}
      <mat-icon class="clear-icon">close</mat-icon>
    </button>
  }
  @if (errorMessageKey()) {
    <p class="dialog-error">{{ errorMessageKey() | transloco }}</p>
  }
</app-paco-dialog>
